<template>
  <div class="new-main centerWidth">
    <div class="tag_position d-flex d-align-center">
      <img src="../assets/images/add1.png" alt="">
      当前位置：<a href="/">首页</a>&gt; <span>考试中心</span>
    </div>
    <div class="new-w9 centerWidth">
      <div class="new-tit-3 d-flex d-align-center">
        <img src="../assets/images/kaoshi.png" alt="">
        <div class="tit cur">共有{{ total }}场考试</div>
      </div>
      <div class="kecheng_wrap d-flex">
        <div class="category-item" v-for="(item,index) in exams" :key="index">
          <template v-if="item.detail.length">
            <img :src="item.detail[0].img?item.detail[0].img:img1" alt="">
            <div class="category-content">
              <h3 class="cate-title">{{ item.name }}</h3>
              <div class="d-flex d-align-center d-just-between">
                <div class="cate-info">
                  <div class="item">
                    <span class="kuai"></span>
                    <span>学　　科：{{ item.detail[0].subject_names[0] }}</span>
                  </div>
                  <div class="item">
                    <span class="kuai"></span>
                    <span>试卷总分：{{ item.detail[0].score }}分</span>
                  </div>
                  <div class="item">
                    <span class="kuai"></span>
                    <span>考试时长：{{ item.detail[0].time }}分钟</span>
                  </div>
                </div>
                <div class="cate-info">
                  <div class="item">
                    <span class="kuai"></span>
                    <span>试卷类型：{{ item.detail[0].type == 1 ? '竞聘考试' : '模拟考试' }}</span>
                  </div>
                  <div class="item">
                    <span class="kuai"></span>
                    <span>及格分数：{{ (item.detail[0].score * 0.6).toFixed(0) }}分</span>
                  </div>
                  <div class="item">
                    <span class="kuai"></span>
                    <span>考试模式：{{ item.detail[0].chongfu_type == 1 ? '不可重复' : item.detail[0].chongfu_type == 2 ? '可重复补考1次' : '不限次数' }}</span>
                  </div>
                </div>
              </div>
              <div class="btn-wrap">
                <button class="cate-link" @click="handleExamClick(item)">{{item.buttonLabel}}</button>
              </div>
            </div>
          </template>
        </div>
      </div>

      <!--      <div style="text-align: center;padding: 20px 0 20px 0">-->
      <!--        <el-pagination-->
      <!--            :page-size="10"-->
      <!--            :current-page="pageNum"-->
      <!--            :background="true"-->
      <!--            layout="prev, pager, next"-->
      <!--            @current-change="currentChange"-->
      <!--            :total="total">-->
      <!--        </el-pagination>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import {
  sjlists
} from "@/api/index";

export default {
  name: "examList",
  data() {
    return {
      list: [],
      total: 0,
      img1:require('../assets/images/fengmian.jpg')
    }
  },
  computed: {
    exams() {
      return this.$store.getters.examsList
    },
  },
  mounted() {
    this.$store.dispatch('fetchExams')
    this.getList()
  },
  methods: {
    getList() {
      sjlists({}).then(res => {
        if (res.code == 1) {
          // this.list = res.data
          this.total = res.data.length
        }
      })
    },
    toStart(item){
      let info = {
        time:item.time,
        id:item.id
      }
      this.$router.push({
        path: '/kaoshi',
        query: {info:JSON.stringify(info)}
      })
    },
    handleExamClick(exam) {
      if (exam.buttonLabel === '开始考试') {
        this.$store.dispatch('startExam', exam.new_id)
      } else {
        this.$store.dispatch('continueExam', exam.new_id)
      }
      // this.$router.push({ query: '/kaoshi' })
      this.$router.push({
        path: '/kaoshi',
        query: {id:exam.detail[0].id,zhunyeId:exam.id}
      })
    },
    currentChange() {

    }
  }
}
</script>

<style scoped lang="scss">
.new-main {
  padding-bottom: 30px;
}

.new-tit-3 {
  //background: hsla(0, 0%, 100%, .4);
  //border-radius: 5px;
  //box-shadow: 0 6px 17px 1px rgba(68, 133, 204, .27);
  margin-top: 20px;
  font-size: 20px;
  font-weight: bold;

  img {
    margin-right: 15px;
  }
}

.new-w9 {
  margin-bottom: 30px;

  .kecheng_wrap {
    margin-top: 30px;
    flex-wrap: wrap;

    .category-item {
      background: #FFFFFF;
      border: 1px solid #EEEEEE;
      padding: 16px;
      cursor: pointer;
      position: relative;
      margin-right: 25px;
      margin-bottom: 25px;

      &:nth-child(3n) {
        margin-right: 0;
      }

      img {
        width: 343px;
        height: 198px;
        border-radius: 8px;
        object-fit: cover;
      }

      .category-content {
        margin-top: 20px;

        .cate-title {
          text-align: center;
          font-weight: bold;
          color: #313F57;
          margin-bottom: 20px;
        }

        .cate-info {
          .item {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 500;
            color: #737D85;
            margin-left: 3px;
            margin-bottom: 10px;

            .kuai {
              width: 6px;
              height: 6px;
              background: #2257ab;
              margin-right: 5px;
            }
          }
        }

        .btn-wrap {
          display: flex;
          justify-content: center;
          margin-top: 10px;

          .cate-link {
            text-align: center;
            font-size: 20px;
            width: 180px;
            height: 50px;
            background: #2257ab;
            color: #FFFFFF;
            font-weight: 500;
            line-height: 50px;
            border-radius: 5px;
          }
        }
      }
    }
  }
}
</style>

